import {useCallback, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch} from "@pg-mono/request";

import {IRPStore} from "../../../app/rp_reducer";
import {useTransitioningHistoryPush} from "../../../hooks/use_transitioning_history_push";
import {trackAmplitudeListingSort} from "../../tracking/amplitude/track_amplitude_listing_sort";
import {resetPrivilegedOfferList} from "../actions/fetch_privileged_offer_list";
import {PRIVILEGE_OFFER_QUERY_PARAM_NAME} from "../constants/offer_list";
import {SearchSortString} from "../constants/SearchSort";

interface UseOfferListSortProps {
    latestQuerySort?: SearchSortString;
    onSubmit: () => void;
}

interface UseOfferListSortReturn {
    currentActive: SearchSortString;
    setCurrentActive: (value: SearchSortString) => void;
    sortHandler: (sortOption: SearchSortString) => void;
}

export const useOfferListSort = ({latestQuerySort, onSubmit}: UseOfferListSortProps): UseOfferListSortReturn => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const {transitionHistory} = useTransitioningHistoryPush();
    const [currentActive, setCurrentActive] = useState(latestQuerySort || SearchSortString.DEFAULT);
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);

    const sortHandler = useCallback(
        (sortOption: SearchSortString) => {
            const search = parseSearch(history.location.search);
            const url = appendQueryString(location.pathname + location.hash, {
                ...omit(search, ["page", PRIVILEGE_OFFER_QUERY_PARAM_NAME]),
                ...(sortOption !== latestQuerySort ? {sort: sortOption.toString()} : {})
            });

            if (sortOption !== latestQuerySort) {
                setCurrentActive(sortOption);
                trackAmplitudeListingSort(sortOption, latestQuery);

                if (search[PRIVILEGE_OFFER_QUERY_PARAM_NAME]) {
                    dispatch(resetPrivilegedOfferList());
                }

                transitionHistory(url);
            }

            if (onSubmit) {
                onSubmit();
            }
        },
        [currentActive, dispatch, history.location.search, location.hash, location.pathname, onSubmit, transitionHistory]
    );

    return {
        currentActive,
        setCurrentActive,
        sortHandler
    };
};
import {useCallback, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch} from "@pg-mono/request";

import {IRPStore} from "../../../app/rp_reducer";
import {useTransitioningHistoryPush} from "../../../hooks/use_transitioning_history_push";
import {trackAmplitudeListingSort} from "../../tracking/amplitude/track_amplitude_listing_sort";
import {resetPrivilegedOfferList} from "../actions/fetch_privileged_offer_list";
import {PRIVILEGE_OFFER_QUERY_PARAM_NAME} from "../constants/offer_list";
import {SearchSortString} from "../constants/SearchSort";

interface UseOfferListSortProps {
    latestQuerySort?: SearchSortString;
    onSubmit: () => void;
}

interface UseOfferListSortReturn {
    currentActive: SearchSortString;
    setCurrentActive: (value: SearchSortString) => void;
    sortHandler: (sortOption: SearchSortString) => void;
}

export const useOfferListSort = ({latestQuerySort, onSubmit}: UseOfferListSortProps): UseOfferListSortReturn => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const {transitionHistory} = useTransitioningHistoryPush();
    const [currentActive, setCurrentActive] = useState(latestQuerySort || SearchSortString.DEFAULT);
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);

    const sortHandler = useCallback(
        (sortOption: SearchSortString) => {
            const search = parseSearch(history.location.search);
            const url = appendQueryString(location.pathname + location.hash, {
                ...omit(search, ["page", PRIVILEGE_OFFER_QUERY_PARAM_NAME]),
                ...(sortOption !== latestQuerySort ? {sort: sortOption.toString()} : {})
            });

            if (sortOption !== latestQuerySort) {
                setCurrentActive(sortOption);
                trackAmplitudeListingSort(sortOption, latestQuery);

                if (search[PRIVILEGE_OFFER_QUERY_PARAM_NAME]) {
                    dispatch(resetPrivilegedOfferList());
                }

                transitionHistory(url);
            }

            if (onSubmit) {
                onSubmit();
            }
        },
        [currentActive, dispatch, history.location.search, location.hash, location.pathname, onSubmit, transitionHistory]
    );

    return {
        currentActive,
        setCurrentActive,
        sortHandler
    };
};
